import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { navLinks } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2" aria-label="策驰漫画网 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">策驰漫画网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              抢先看最新话，同步更新进度，汉化进度实时查。热门连载、追更动态一目了然，让追更不再错过。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-600">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" aria-label="公众号" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-wechat-2-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">漫画分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-3 text-sm text-foreground-600">
              {categories.filter((c) => c !== '全部').map((c) => (
                <li key={c}>
                  <Link to={`/comics?category=${encodeURIComponent(c)}`} className="transition-colors hover:text-primary-600">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>contact@cechi-mh.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>每日 09:00 - 22:00 在线
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i>更新问题优先处理
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 策驰漫画网 · 抢先看最新话，同步更新进度，汉化进度实时查</p>
          <p className="flex items-center gap-1">
            支持电脑 / 平板 / 手机 · <i className="ri-heart-3-fill text-primary-500"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}